import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { systemAdminRoute } from "routes/sfg20-admin/system-admin-app.runtime"
import { SystemAdminPageGuard } from "routes/sfg20-admin/plugins/system-tab/system-admin-page-guard"

/**
 * Registers a System Admin page: a route under the System Admin application plus a
 * matching left-hand nav item. This is the standard per-app navigation pattern and
 * replaces the previous horizontal tab strip. The route is guarded by the same
 * predicate as the nav item, so a hidden page is not reachable by direct URL.
 *
 * @param {object} options
 * @param {string} options.name - Display name shown in the sidebar and page title.
 * @param {string} options.path - Sub-path under `/system-admin` (e.g. "settings").
 * @param {React.ReactNode} options.content - The page content component.
 * @param {string|React.ReactNode} [options.icon] - Iconify key (or element) for the nav item.
 * @param {() => boolean} [options.predicate] - Controls nav-item visibility and route access.
 * @param {number} [options.priority] - Sidebar ordering (lower first).
 * @param {string} [options.group] - Section heading to sit under; see system-admin-sections.js.
 *     Omitted, the page sits above the first section. Section order follows from priority.
 */
export function registerSystemAdminPage({
    name,
    path,
    content,
    icon = "mdi:cog-outline",
    predicate = () => true,
    priority = 100,
    group,
}) {
    systemAdminRoute.register(path, <SystemAdminPageGuard predicate={predicate}>{content}</SystemAdminPageGuard>)
    registerConditionalPageNavigation(predicate, `/system-admin/${path}`, name, icon, { priority, group })
}
